/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export const Description = styled.div({
  font: token('font.body.small'),
  color: token('color.text.subtle'),
});

export const ChangedValueStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 'space.050',
  gap: 'space.100',
  font: token('font.heading.large'),
  fontWeight: token('font.weight.regular'),
});

export const CurrentValue = styled('div')<{ isImproved: boolean }>(
  ({ isImproved }) => ({
    color: isImproved
      ? token('color.text.accent.green')
      : token('color.text.accent.red'),
  })
);

export const LozengeDifference = styled.span({
  display: 'inline-block',
  verticalAlign: 'text-bottom',
});

export const tooltipStyles = {
  color: token('color.text.inverse'),
  backgroundColor: token('color.background.neutral.bold.hovered'),
};

export const TooltipWrapper = styled.div({
  padding: token('space.100'),
});

export const ValueDifference = styled('span')<{ isImproved: boolean }>(
  ({ isImproved }) => ({
    fontWeight: token('font.weight.semibold'),
    color: isImproved
      ? token('color.text.accent.green')
      : token('color.text.accent.red'),
  })
);

export const SpinnerWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
});

export const MessageWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
});
